import { ContextStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { CompareToggle } from '@shared-ui/retail-compare-toggle';
import { IClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { ILocalization, LocalizedComponentProps, withLocalization } from '@shared-ui/localization-context';
import { SortAndFiltersViewType } from '@shared-ui/retail-sort-and-filter-lodging';
import { TOGGLE_PLACEMENT_FILTERS_SHEET } from '@shared-ui/retail-compare-providers';
import { useLodgingURLParamsToQueryInputs } from '@shared-ui/search-tools-lodging';

import { getPropertySearchInput } from 'stores/adapters';
import { MultiItemStore } from 'src/common/stores/multi-item-store';
import { SearchCriteriaModel } from 'stores/models';
import { SearchResultsStore } from 'stores/search-results-store';
import { ViewTracker } from 'stores/contexts/viewTracker';

import { SortAndFilterModel } from 'components/common/search-form/fields/filter-types';

import { UitkSpacing } from 'uitk-react-spacing';

import { MapPreview } from 'components/search/map/map-preview';
import { parse } from 'query-string';
import { UniversalSortFilterWrapper } from './sort-filter/universal-sort-filter';

export interface SidebarProps extends RouteComponentProps {
  context?: ContextStore;
  searchResults?: SearchResultsStore;
  l10n?: ILocalization;
  withFilters?: boolean;
  tracker: IClickstreamAnalytics;
  viewTracker: ViewTracker;
  mapSortAndFilterViewType?: SortAndFiltersViewType;
  multiItem?: MultiItemStore;
  searchCriteria?: SearchCriteriaModel;
}
type LocalizedSidebarProps = SidebarProps & LocalizedComponentProps;

const SidebarComponent: React.FC<LocalizedSidebarProps> = inject(
  'context',
  'searchCriteria',
  'searchResults',
  'multiItem'
)(
  ({
    l10n,
    context,
    searchResults,
    withFilters = true,
    tracker,
    viewTracker,
    mapSortAndFilterViewType,
    location,
    multiItem,
    searchCriteria,
  }) => {
    const lodgingQueryInputs = useLodgingURLParamsToQueryInputs();

    if (!context || !searchResults || !searchCriteria) return null;

    const searchResultsCriteria = searchResults.searchCriteria;
    const regionId = searchResultsCriteria?.regionId;
    const latLong = searchResultsCriteria?.latLong;
    const group = searchResultsCriteria?.group;
    const formatText = l10n?.formatText;

    const sortAndFilterOptions: SortAndFilterModel = searchResults?.sortAndFilter?.options;
    const pwaMapOverlay = Boolean(parse(location.search).pwaOverlay === 'map');
    const shouldShowSidebar = regionId || latLong || group || sortAndFilterOptions;

    const inputs = getPropertySearchInput(context, searchCriteria, multiItem?.multiItemContext);
    const rooms = lodgingQueryInputs?.propertySearchCriteriaInput?.primary.rooms;

    if (inputs?.criteria?.primary && rooms) {
      inputs.criteria.primary.rooms = rooms;
    }

    return (
      <section data-stid="desktop-sidebar">
        <MapPreview viewTracker={viewTracker} tracker={tracker} mapSortAndFilterViewType={mapSortAndFilterViewType} searchInputs={inputs} />
        {shouldShowSidebar && withFilters && (
          <>
            <CompareToggle placement={TOGGLE_PLACEMENT_FILTERS_SHEET} />
            <h2 className="is-visually-hidden">{formatText && formatText('hotels.searchResults.filtersDialog.title')}</h2>
            {!pwaMapOverlay && (
              <UitkSpacing padding={{ blockend: 'twelve' }}>
                <UniversalSortFilterWrapper view={SortAndFiltersViewType.FILTERS} />
              </UitkSpacing>
            )}
          </>
        )}
      </section>
    );
  }
);

export const Sidebar = withLocalization(withRouter(SidebarComponent));
